import React, { FC, HTMLAttributes, ReactNode, useState } from 'react';
export interface TableRowProps extends HTMLAttributes<HTMLDivElement> {
  children?: (data?: any) => ReactNode;
  variant: 'accordion' | 'static';
  compact?: boolean;
}

export const TableRow: FC<TableRowProps> = ({
  children,
  compact,
  variant,
  ...rest
}: TableRowProps) => {
  const renderStaticInfoRow =
    variant === 'static' ? (
      <div className="w-full" {...rest}>
        <div
          className={`px-[30px] ${
            compact ? 'py-[16px]' : 'py-[30px]'
          }  w-full flex justify-between items-center border-b border-thryv-gray-light-400 hover:bg-thryv-white-200 transition-all duration-300 ease-in`}
        >
          {children}
        </div>
      </div>
    ) : null;

  const [show, setShow] = useState<boolean>(false);

  const renderExpandInfoRow =
    variant === 'accordion' ? (
      <div className="w-full border-b border-thryv-gray-light-400 ">
        <div>{children && children({ show, setShow, compact })}</div>
      </div>
    ) : null;
  return (
    <>
      {renderStaticInfoRow}
      {renderExpandInfoRow}
    </>
  );
};
